// source: messages/providers.message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.providers_messages.DeleteProviderRateRequest', null, global);
goog.exportSymbol('proto.providers_messages.DeleteProviderRateResponse', null, global);
goog.exportSymbol('proto.providers_messages.GetProviderRatesRequest', null, global);
goog.exportSymbol('proto.providers_messages.GetProviderRatesResponse', null, global);
goog.exportSymbol('proto.providers_messages.Provider', null, global);
goog.exportSymbol('proto.providers_messages.ProviderActivity', null, global);
goog.exportSymbol('proto.providers_messages.ProviderBillingLimit', null, global);
goog.exportSymbol('proto.providers_messages.ProviderCreateActivityRequest', null, global);
goog.exportSymbol('proto.providers_messages.ProviderCreateActivityResponse', null, global);
goog.exportSymbol('proto.providers_messages.ProviderRate', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetBillingLimitsRequest', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetBillingLimitsResponse', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetNotificationPreferencesRequest', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetNotificationPreferencesResponse', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetRequest', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersGetResponse', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersSearchRequest', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersSearchResponse', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest', null, global);
goog.exportSymbol('proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse', null, global);
goog.exportSymbol('proto.providers_messages.UpsertProviderRateRequest', null, global);
goog.exportSymbol('proto.providers_messages.UpsertProviderRateResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.Provider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.Provider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.Provider.displayName = 'proto.providers_messages.Provider';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProviderBillingLimit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProviderBillingLimit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProviderBillingLimit.displayName = 'proto.providers_messages.ProviderBillingLimit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersSearchRequest.displayName = 'proto.providers_messages.ProvidersSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.providers_messages.ProvidersSearchResponse.repeatedFields_, null);
};
goog.inherits(proto.providers_messages.ProvidersSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersSearchResponse.displayName = 'proto.providers_messages.ProvidersSearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersGetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetRequest.displayName = 'proto.providers_messages.ProvidersGetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersGetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetResponse.displayName = 'proto.providers_messages.ProvidersGetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.providers_messages.ProvidersGetBillingLimitsRequest.repeatedFields_, null);
};
goog.inherits(proto.providers_messages.ProvidersGetBillingLimitsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetBillingLimitsRequest.displayName = 'proto.providers_messages.ProvidersGetBillingLimitsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.providers_messages.ProvidersGetBillingLimitsResponse.repeatedFields_, null);
};
goog.inherits(proto.providers_messages.ProvidersGetBillingLimitsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetBillingLimitsResponse.displayName = 'proto.providers_messages.ProvidersGetBillingLimitsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersGetNotificationPreferencesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetNotificationPreferencesRequest.displayName = 'proto.providers_messages.ProvidersGetNotificationPreferencesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersGetNotificationPreferencesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetNotificationPreferencesResponse.displayName = 'proto.providers_messages.ProvidersGetNotificationPreferencesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.displayName = 'proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.displayName = 'proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.displayName = 'proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.displayName = 'proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProviderActivity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProviderActivity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProviderActivity.displayName = 'proto.providers_messages.ProviderActivity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProviderCreateActivityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProviderCreateActivityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProviderCreateActivityRequest.displayName = 'proto.providers_messages.ProviderCreateActivityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProviderCreateActivityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProviderCreateActivityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProviderCreateActivityResponse.displayName = 'proto.providers_messages.ProviderCreateActivityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.ProviderRate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.ProviderRate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.ProviderRate.displayName = 'proto.providers_messages.ProviderRate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.GetProviderRatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.GetProviderRatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.GetProviderRatesRequest.displayName = 'proto.providers_messages.GetProviderRatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.GetProviderRatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.providers_messages.GetProviderRatesResponse.repeatedFields_, null);
};
goog.inherits(proto.providers_messages.GetProviderRatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.GetProviderRatesResponse.displayName = 'proto.providers_messages.GetProviderRatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.UpsertProviderRateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.UpsertProviderRateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.UpsertProviderRateRequest.displayName = 'proto.providers_messages.UpsertProviderRateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.UpsertProviderRateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.UpsertProviderRateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.UpsertProviderRateResponse.displayName = 'proto.providers_messages.UpsertProviderRateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.DeleteProviderRateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.DeleteProviderRateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.DeleteProviderRateRequest.displayName = 'proto.providers_messages.DeleteProviderRateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.providers_messages.DeleteProviderRateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.providers_messages.DeleteProviderRateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.providers_messages.DeleteProviderRateResponse.displayName = 'proto.providers_messages.DeleteProviderRateResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.Provider.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.Provider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.Provider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.Provider.toObject = function(includeInstance, msg) {
  var f, obj = {
attyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
namefirst: jspb.Message.getFieldWithDefault(msg, 2, ""),
namelast: jspb.Message.getFieldWithDefault(msg, 3, ""),
email: jspb.Message.getFieldWithDefault(msg, 4, ""),
city: jspb.Message.getFieldWithDefault(msg, 5, ""),
state: jspb.Message.getFieldWithDefault(msg, 6, ""),
zip: jspb.Message.getFieldWithDefault(msg, 7, ""),
updateInfoToken: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.Provider}
 */
proto.providers_messages.Provider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.Provider;
  return proto.providers_messages.Provider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.Provider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.Provider}
 */
proto.providers_messages.Provider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamefirst(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamelast(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateInfoToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.Provider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.Provider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.Provider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.Provider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNamefirst();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamelast();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int32 attyId = 1;
 * @return {number}
 */
proto.providers_messages.Provider.prototype.getAttyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setAttyid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string nameFirst = 2;
 * @return {string}
 */
proto.providers_messages.Provider.prototype.getNamefirst = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setNamefirst = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nameLast = 3;
 * @return {string}
 */
proto.providers_messages.Provider.prototype.getNamelast = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setNamelast = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.providers_messages.Provider.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.providers_messages.Provider.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string state = 6;
 * @return {string}
 */
proto.providers_messages.Provider.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string zip = 7;
 * @return {string}
 */
proto.providers_messages.Provider.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string update_info_token = 8;
 * @return {string}
 */
proto.providers_messages.Provider.prototype.getUpdateInfoToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.setUpdateInfoToken = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.Provider} returns this
 */
proto.providers_messages.Provider.prototype.clearUpdateInfoToken = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.Provider.prototype.hasUpdateInfoToken = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProviderBillingLimit.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProviderBillingLimit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProviderBillingLimit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderBillingLimit.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
attorneyid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
casereferralid: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
matterbillingcode: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
mattertitle: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
matterpaymentparameters: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
hourlyrate: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
totalhours: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
totalamount: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
createdat: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
createdby: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
createdfullname: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
createroleid: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
updatedat: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
updatedby: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
updatedfullname: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
updateroleid: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
additionalhours: (f = jspb.Message.getField(msg, 18)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProviderBillingLimit}
 */
proto.providers_messages.ProviderBillingLimit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProviderBillingLimit;
  return proto.providers_messages.ProviderBillingLimit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProviderBillingLimit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProviderBillingLimit}
 */
proto.providers_messages.ProviderBillingLimit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttorneyid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCasereferralid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterbillingcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMattertitle(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterpaymentparameters(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setHourlyrate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalhours(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalamount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedat(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedby(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedfullname(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreateroleid(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedat(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUpdatedby(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedfullname(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateroleid(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdditionalhours(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProviderBillingLimit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProviderBillingLimit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProviderBillingLimit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderBillingLimit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeString(
      16,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 attorneyId = 2;
 * @return {number}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getAttorneyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setAttorneyid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearAttorneyid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasAttorneyid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 caseReferralId = 3;
 * @return {number}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getCasereferralid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setCasereferralid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearCasereferralid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasCasereferralid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string matterBillingCode = 4;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getMatterbillingcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setMatterbillingcode = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearMatterbillingcode = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasMatterbillingcode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string matterTitle = 5;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getMattertitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setMattertitle = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearMattertitle = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasMattertitle = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string matterPaymentParameters = 6;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getMatterpaymentparameters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setMatterpaymentparameters = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearMatterpaymentparameters = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasMatterpaymentparameters = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string hourlyRate = 7;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getHourlyrate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setHourlyrate = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearHourlyrate = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasHourlyrate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string totalHours = 8;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getTotalhours = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setTotalhours = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearTotalhours = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasTotalhours = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string totalAmount = 9;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getTotalamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setTotalamount = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearTotalamount = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasTotalamount = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string createdAt = 10;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getCreatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setCreatedat = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearCreatedat = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int32 createdBy = 11;
 * @return {number}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getCreatedby = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setCreatedby = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearCreatedby = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasCreatedby = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string createdFullName = 12;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getCreatedfullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setCreatedfullname = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearCreatedfullname = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasCreatedfullname = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string createRoleId = 13;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getCreateroleid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setCreateroleid = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearCreateroleid = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasCreateroleid = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string updatedAt = 14;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getUpdatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setUpdatedat = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearUpdatedat = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasUpdatedat = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional int32 updatedBy = 15;
 * @return {number}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getUpdatedby = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setUpdatedby = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearUpdatedby = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasUpdatedby = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string updatedFullName = 16;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getUpdatedfullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setUpdatedfullname = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearUpdatedfullname = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasUpdatedfullname = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string updateRoleId = 17;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getUpdateroleid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setUpdateroleid = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearUpdateroleid = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasUpdateroleid = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string additionalHours = 18;
 * @return {string}
 */
proto.providers_messages.ProviderBillingLimit.prototype.getAdditionalhours = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.setAdditionalhours = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderBillingLimit} returns this
 */
proto.providers_messages.ProviderBillingLimit.prototype.clearAdditionalhours = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderBillingLimit.prototype.hasAdditionalhours = function() {
  return jspb.Message.getField(this, 18) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
term: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersSearchRequest}
 */
proto.providers_messages.ProvidersSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersSearchRequest;
  return proto.providers_messages.ProvidersSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersSearchRequest}
 */
proto.providers_messages.ProvidersSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTerm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string term = 1;
 * @return {string}
 */
proto.providers_messages.ProvidersSearchRequest.prototype.getTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProvidersSearchRequest} returns this
 */
proto.providers_messages.ProvidersSearchRequest.prototype.setTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.providers_messages.ProvidersSearchResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
providersList: jspb.Message.toObjectList(msg.getProvidersList(),
    proto.providers_messages.Provider.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersSearchResponse}
 */
proto.providers_messages.ProvidersSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersSearchResponse;
  return proto.providers_messages.ProvidersSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersSearchResponse}
 */
proto.providers_messages.ProvidersSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.providers_messages.Provider;
      reader.readMessage(value,proto.providers_messages.Provider.deserializeBinaryFromReader);
      msg.addProviders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProvidersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.providers_messages.Provider.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Provider providers = 1;
 * @return {!Array<!proto.providers_messages.Provider>}
 */
proto.providers_messages.ProvidersSearchResponse.prototype.getProvidersList = function() {
  return /** @type{!Array<!proto.providers_messages.Provider>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.providers_messages.Provider, 1));
};


/**
 * @param {!Array<!proto.providers_messages.Provider>} value
 * @return {!proto.providers_messages.ProvidersSearchResponse} returns this
*/
proto.providers_messages.ProvidersSearchResponse.prototype.setProvidersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.providers_messages.Provider=} opt_value
 * @param {number=} opt_index
 * @return {!proto.providers_messages.Provider}
 */
proto.providers_messages.ProvidersSearchResponse.prototype.addProviders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.providers_messages.Provider, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.providers_messages.ProvidersSearchResponse} returns this
 */
proto.providers_messages.ProvidersSearchResponse.prototype.clearProvidersList = function() {
  return this.setProvidersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attyid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetRequest}
 */
proto.providers_messages.ProvidersGetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetRequest;
  return proto.providers_messages.ProvidersGetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetRequest}
 */
proto.providers_messages.ProvidersGetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 attyId = 1;
 * @return {number}
 */
proto.providers_messages.ProvidersGetRequest.prototype.getAttyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProvidersGetRequest} returns this
 */
proto.providers_messages.ProvidersGetRequest.prototype.setAttyid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
provider: (f = msg.getProvider()) && proto.providers_messages.Provider.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetResponse}
 */
proto.providers_messages.ProvidersGetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetResponse;
  return proto.providers_messages.ProvidersGetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetResponse}
 */
proto.providers_messages.ProvidersGetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.providers_messages.Provider;
      reader.readMessage(value,proto.providers_messages.Provider.deserializeBinaryFromReader);
      msg.setProvider(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProvider();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.providers_messages.Provider.serializeBinaryToWriter
    );
  }
};


/**
 * optional Provider provider = 1;
 * @return {?proto.providers_messages.Provider}
 */
proto.providers_messages.ProvidersGetResponse.prototype.getProvider = function() {
  return /** @type{?proto.providers_messages.Provider} */ (
    jspb.Message.getWrapperField(this, proto.providers_messages.Provider, 1));
};


/**
 * @param {?proto.providers_messages.Provider|undefined} value
 * @return {!proto.providers_messages.ProvidersGetResponse} returns this
*/
proto.providers_messages.ProvidersGetResponse.prototype.setProvider = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.providers_messages.ProvidersGetResponse} returns this
 */
proto.providers_messages.ProvidersGetResponse.prototype.clearProvider = function() {
  return this.setProvider(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetResponse.prototype.hasProvider = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetBillingLimitsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetBillingLimitsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
lampCaseId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
matterBillingCodesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetBillingLimitsRequest;
  return proto.providers_messages.ProvidersGetBillingLimitsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetBillingLimitsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLampCaseId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addMatterBillingCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetBillingLimitsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetBillingLimitsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMatterBillingCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional int32 atty_id = 1;
 * @return {number}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest} returns this
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lamp_case_id = 2;
 * @return {number}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.getLampCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest} returns this
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.setLampCaseId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest} returns this
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.clearLampCaseId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.hasLampCaseId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string matter_billing_codes = 3;
 * @return {!Array<string>}
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.getMatterBillingCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest} returns this
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.setMatterBillingCodesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest} returns this
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.addMatterBillingCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsRequest} returns this
 */
proto.providers_messages.ProvidersGetBillingLimitsRequest.prototype.clearMatterBillingCodesList = function() {
  return this.setMatterBillingCodesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetBillingLimitsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetBillingLimitsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
billingLimitsList: jspb.Message.toObjectList(msg.getBillingLimitsList(),
    proto.providers_messages.ProviderBillingLimit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsResponse}
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetBillingLimitsResponse;
  return proto.providers_messages.ProvidersGetBillingLimitsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetBillingLimitsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsResponse}
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.providers_messages.ProviderBillingLimit;
      reader.readMessage(value,proto.providers_messages.ProviderBillingLimit.deserializeBinaryFromReader);
      msg.addBillingLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetBillingLimitsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetBillingLimitsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingLimitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.providers_messages.ProviderBillingLimit.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProviderBillingLimit billing_limits = 1;
 * @return {!Array<!proto.providers_messages.ProviderBillingLimit>}
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.prototype.getBillingLimitsList = function() {
  return /** @type{!Array<!proto.providers_messages.ProviderBillingLimit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.providers_messages.ProviderBillingLimit, 1));
};


/**
 * @param {!Array<!proto.providers_messages.ProviderBillingLimit>} value
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsResponse} returns this
*/
proto.providers_messages.ProvidersGetBillingLimitsResponse.prototype.setBillingLimitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.providers_messages.ProviderBillingLimit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.providers_messages.ProviderBillingLimit}
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.prototype.addBillingLimits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.providers_messages.ProviderBillingLimit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.providers_messages.ProvidersGetBillingLimitsResponse} returns this
 */
proto.providers_messages.ProvidersGetBillingLimitsResponse.prototype.clearBillingLimitsList = function() {
  return this.setBillingLimitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetNotificationPreferencesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesRequest}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetNotificationPreferencesRequest;
  return proto.providers_messages.ProvidersGetNotificationPreferencesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesRequest}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetNotificationPreferencesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesRequest} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetNotificationPreferencesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
onInReview: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
onApproved: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
onQueued: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
onClosedPaid: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetNotificationPreferencesResponse;
  return proto.providers_messages.ProvidersGetNotificationPreferencesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnInReview(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnApproved(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnQueued(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnClosedPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetNotificationPreferencesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnInReview();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getOnApproved();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOnQueued();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOnClosedPaid();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool on_in_review = 1;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.getOnInReview = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.setOnInReview = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool on_approved = 2;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.getOnApproved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.setOnApproved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool on_queued = 3;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.getOnQueued = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.setOnQueued = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool on_closed_paid = 4;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.getOnClosedPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesResponse.prototype.setOnClosedPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
onInReview: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
onApproved: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
onQueued: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
onClosedPaid: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest;
  return proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnInReview(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnApproved(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnQueued(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnClosedPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOnInReview();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOnApproved();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOnQueued();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOnClosedPaid();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool on_in_review = 2;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.getOnInReview = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.setOnInReview = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool on_approved = 3;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.getOnApproved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.setOnApproved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool on_queued = 4;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.getOnQueued = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.setOnQueued = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool on_closed_paid = 5;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.getOnClosedPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesRequest.prototype.setOnClosedPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
onInReview: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
onApproved: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
onQueued: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
onClosedPaid: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse;
  return proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnInReview(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnApproved(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnQueued(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnClosedPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnInReview();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getOnApproved();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOnQueued();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOnClosedPaid();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool on_in_review = 1;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.getOnInReview = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.setOnInReview = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool on_approved = 2;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.getOnApproved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.setOnApproved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool on_queued = 3;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.getOnQueued = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.setOnQueued = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool on_closed_paid = 4;
 * @return {boolean}
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.getOnClosedPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse} returns this
 */
proto.providers_messages.ProvidersUpdateNotificationPreferencesResponse.prototype.setOnClosedPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
externalUserId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest;
  return proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExternalUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string external_user_id = 1;
 * @return {string}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.prototype.getExternalUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdRequest.prototype.setExternalUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
onInReview: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
onApproved: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
onQueued: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
onClosedPaid: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse;
  return proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnInReview(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnApproved(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnQueued(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnClosedPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnInReview();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getOnApproved();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOnQueued();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOnClosedPaid();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool on_in_review = 1;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.getOnInReview = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.setOnInReview = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool on_approved = 2;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.getOnApproved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.setOnApproved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool on_queued = 3;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.getOnQueued = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.setOnQueued = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool on_closed_paid = 4;
 * @return {boolean}
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.getOnClosedPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse} returns this
 */
proto.providers_messages.ProvidersGetNotificationPreferencesByExternalUserIdResponse.prototype.setOnClosedPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProviderActivity.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProviderActivity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProviderActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderActivity.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
activityType: jspb.Message.getFieldWithDefault(msg, 3, ""),
activityMessage: jspb.Message.getFieldWithDefault(msg, 4, ""),
activityLog: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProviderActivity}
 */
proto.providers_messages.ProviderActivity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProviderActivity;
  return proto.providers_messages.ProviderActivity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProviderActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProviderActivity}
 */
proto.providers_messages.ProviderActivity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityMessage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityLog(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProviderActivity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProviderActivity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProviderActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderActivity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActivityType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActivityMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActivityLog();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.providers_messages.ProviderActivity.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderActivity} returns this
 */
proto.providers_messages.ProviderActivity.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.providers_messages.ProviderActivity.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderActivity} returns this
 */
proto.providers_messages.ProviderActivity.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string activity_type = 3;
 * @return {string}
 */
proto.providers_messages.ProviderActivity.prototype.getActivityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderActivity} returns this
 */
proto.providers_messages.ProviderActivity.prototype.setActivityType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string activity_message = 4;
 * @return {string}
 */
proto.providers_messages.ProviderActivity.prototype.getActivityMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderActivity} returns this
 */
proto.providers_messages.ProviderActivity.prototype.setActivityMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string activity_log = 5;
 * @return {string}
 */
proto.providers_messages.ProviderActivity.prototype.getActivityLog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderActivity} returns this
 */
proto.providers_messages.ProviderActivity.prototype.setActivityLog = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.providers_messages.ProviderActivity.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderActivity} returns this
 */
proto.providers_messages.ProviderActivity.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderActivity} returns this
 */
proto.providers_messages.ProviderActivity.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderActivity.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProviderCreateActivityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProviderCreateActivityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderCreateActivityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
activityType: jspb.Message.getFieldWithDefault(msg, 2, ""),
activityMessage: jspb.Message.getFieldWithDefault(msg, 3, ""),
activityLog: jspb.Message.getFieldWithDefault(msg, 4, ""),
createdAt: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProviderCreateActivityRequest}
 */
proto.providers_messages.ProviderCreateActivityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProviderCreateActivityRequest;
  return proto.providers_messages.ProviderCreateActivityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProviderCreateActivityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProviderCreateActivityRequest}
 */
proto.providers_messages.ProviderCreateActivityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityMessage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityLog(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProviderCreateActivityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProviderCreateActivityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderCreateActivityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActivityType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActivityMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActivityLog();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderCreateActivityRequest} returns this
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string activity_type = 2;
 * @return {string}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.getActivityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderCreateActivityRequest} returns this
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.setActivityType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string activity_message = 3;
 * @return {string}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.getActivityMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderCreateActivityRequest} returns this
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.setActivityMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string activity_log = 4;
 * @return {string}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.getActivityLog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderCreateActivityRequest} returns this
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.setActivityLog = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 created_at = 5;
 * @return {number}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderCreateActivityRequest} returns this
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderCreateActivityRequest} returns this
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderCreateActivityRequest.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProviderCreateActivityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProviderCreateActivityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProviderCreateActivityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderCreateActivityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProviderCreateActivityResponse}
 */
proto.providers_messages.ProviderCreateActivityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProviderCreateActivityResponse;
  return proto.providers_messages.ProviderCreateActivityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProviderCreateActivityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProviderCreateActivityResponse}
 */
proto.providers_messages.ProviderCreateActivityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProviderCreateActivityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProviderCreateActivityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProviderCreateActivityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderCreateActivityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.ProviderRate.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.ProviderRate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.ProviderRate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderRate.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
attyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
benefitCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
standardHourlyRate: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
standardFlatRate: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
createdAt: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
updatedAt: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.ProviderRate}
 */
proto.providers_messages.ProviderRate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.ProviderRate;
  return proto.providers_messages.ProviderRate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.ProviderRate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.ProviderRate}
 */
proto.providers_messages.ProviderRate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttyId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandardHourlyRate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandardFlatRate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.ProviderRate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.ProviderRate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.ProviderRate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.ProviderRate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAttyId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBenefitCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.providers_messages.ProviderRate.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string atty_id = 2;
 * @return {string}
 */
proto.providers_messages.ProviderRate.prototype.getAttyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.setAttyId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string benefit_code = 3;
 * @return {string}
 */
proto.providers_messages.ProviderRate.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.setBenefitCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string standard_hourly_rate = 4;
 * @return {string}
 */
proto.providers_messages.ProviderRate.prototype.getStandardHourlyRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.setStandardHourlyRate = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.clearStandardHourlyRate = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderRate.prototype.hasStandardHourlyRate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string standard_flat_rate = 5;
 * @return {string}
 */
proto.providers_messages.ProviderRate.prototype.getStandardFlatRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.setStandardFlatRate = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.clearStandardFlatRate = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderRate.prototype.hasStandardFlatRate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.providers_messages.ProviderRate.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderRate.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int64 updated_at = 7;
 * @return {number}
 */
proto.providers_messages.ProviderRate.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.ProviderRate} returns this
 */
proto.providers_messages.ProviderRate.prototype.clearUpdatedAt = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.ProviderRate.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.GetProviderRatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.GetProviderRatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.GetProviderRatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.GetProviderRatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attyId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.GetProviderRatesRequest}
 */
proto.providers_messages.GetProviderRatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.GetProviderRatesRequest;
  return proto.providers_messages.GetProviderRatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.GetProviderRatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.GetProviderRatesRequest}
 */
proto.providers_messages.GetProviderRatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.GetProviderRatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.GetProviderRatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.GetProviderRatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.GetProviderRatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string atty_id = 1;
 * @return {string}
 */
proto.providers_messages.GetProviderRatesRequest.prototype.getAttyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.GetProviderRatesRequest} returns this
 */
proto.providers_messages.GetProviderRatesRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.providers_messages.GetProviderRatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.GetProviderRatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.GetProviderRatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.GetProviderRatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.GetProviderRatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
ratesList: jspb.Message.toObjectList(msg.getRatesList(),
    proto.providers_messages.ProviderRate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.GetProviderRatesResponse}
 */
proto.providers_messages.GetProviderRatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.GetProviderRatesResponse;
  return proto.providers_messages.GetProviderRatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.GetProviderRatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.GetProviderRatesResponse}
 */
proto.providers_messages.GetProviderRatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.providers_messages.ProviderRate;
      reader.readMessage(value,proto.providers_messages.ProviderRate.deserializeBinaryFromReader);
      msg.addRates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.GetProviderRatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.GetProviderRatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.GetProviderRatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.GetProviderRatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.providers_messages.ProviderRate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProviderRate rates = 1;
 * @return {!Array<!proto.providers_messages.ProviderRate>}
 */
proto.providers_messages.GetProviderRatesResponse.prototype.getRatesList = function() {
  return /** @type{!Array<!proto.providers_messages.ProviderRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.providers_messages.ProviderRate, 1));
};


/**
 * @param {!Array<!proto.providers_messages.ProviderRate>} value
 * @return {!proto.providers_messages.GetProviderRatesResponse} returns this
*/
proto.providers_messages.GetProviderRatesResponse.prototype.setRatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.providers_messages.ProviderRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.providers_messages.ProviderRate}
 */
proto.providers_messages.GetProviderRatesResponse.prototype.addRates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.providers_messages.ProviderRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.providers_messages.GetProviderRatesResponse} returns this
 */
proto.providers_messages.GetProviderRatesResponse.prototype.clearRatesList = function() {
  return this.setRatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.UpsertProviderRateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.UpsertProviderRateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.UpsertProviderRateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
benefitCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
standardHourlyRate: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
standardFlatRate: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
userId: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.UpsertProviderRateRequest}
 */
proto.providers_messages.UpsertProviderRateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.UpsertProviderRateRequest;
  return proto.providers_messages.UpsertProviderRateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.UpsertProviderRateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.UpsertProviderRateRequest}
 */
proto.providers_messages.UpsertProviderRateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandardHourlyRate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandardFlatRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.UpsertProviderRateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.UpsertProviderRateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.UpsertProviderRateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBenefitCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string atty_id = 1;
 * @return {string}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.getAttyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string benefit_code = 2;
 * @return {string}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.setBenefitCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string standard_hourly_rate = 3;
 * @return {string}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.getStandardHourlyRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.setStandardHourlyRate = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.clearStandardHourlyRate = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.hasStandardHourlyRate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string standard_flat_rate = 4;
 * @return {string}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.getStandardFlatRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.setStandardFlatRate = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.clearStandardFlatRate = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.hasStandardFlatRate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 user_id = 5;
 * @return {number}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.setUserId = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.UpsertProviderRateRequest} returns this
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.clearUserId = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.UpsertProviderRateRequest.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.UpsertProviderRateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.UpsertProviderRateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.UpsertProviderRateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.UpsertProviderRateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
rate: (f = msg.getRate()) && proto.providers_messages.ProviderRate.toObject(includeInstance, f),
wasCreated: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.UpsertProviderRateResponse}
 */
proto.providers_messages.UpsertProviderRateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.UpsertProviderRateResponse;
  return proto.providers_messages.UpsertProviderRateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.UpsertProviderRateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.UpsertProviderRateResponse}
 */
proto.providers_messages.UpsertProviderRateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.providers_messages.ProviderRate;
      reader.readMessage(value,proto.providers_messages.ProviderRate.deserializeBinaryFromReader);
      msg.setRate(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWasCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.UpsertProviderRateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.UpsertProviderRateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.UpsertProviderRateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.UpsertProviderRateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.providers_messages.ProviderRate.serializeBinaryToWriter
    );
  }
  f = message.getWasCreated();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional ProviderRate rate = 1;
 * @return {?proto.providers_messages.ProviderRate}
 */
proto.providers_messages.UpsertProviderRateResponse.prototype.getRate = function() {
  return /** @type{?proto.providers_messages.ProviderRate} */ (
    jspb.Message.getWrapperField(this, proto.providers_messages.ProviderRate, 1));
};


/**
 * @param {?proto.providers_messages.ProviderRate|undefined} value
 * @return {!proto.providers_messages.UpsertProviderRateResponse} returns this
*/
proto.providers_messages.UpsertProviderRateResponse.prototype.setRate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.providers_messages.UpsertProviderRateResponse} returns this
 */
proto.providers_messages.UpsertProviderRateResponse.prototype.clearRate = function() {
  return this.setRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.UpsertProviderRateResponse.prototype.hasRate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool was_created = 2;
 * @return {boolean}
 */
proto.providers_messages.UpsertProviderRateResponse.prototype.getWasCreated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.providers_messages.UpsertProviderRateResponse} returns this
 */
proto.providers_messages.UpsertProviderRateResponse.prototype.setWasCreated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.DeleteProviderRateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.DeleteProviderRateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.DeleteProviderRateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
attyId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
benefitCode: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.DeleteProviderRateRequest}
 */
proto.providers_messages.DeleteProviderRateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.DeleteProviderRateRequest;
  return proto.providers_messages.DeleteProviderRateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.DeleteProviderRateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.DeleteProviderRateRequest}
 */
proto.providers_messages.DeleteProviderRateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttyId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.DeleteProviderRateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.DeleteProviderRateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.DeleteProviderRateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.DeleteProviderRateRequest} returns this
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.providers_messages.DeleteProviderRateRequest} returns this
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.setUserId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.DeleteProviderRateRequest} returns this
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.clearUserId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string atty_id = 3;
 * @return {string}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.getAttyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.DeleteProviderRateRequest} returns this
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.DeleteProviderRateRequest} returns this
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.clearAttyId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.hasAttyId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string benefit_code = 4;
 * @return {string}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.providers_messages.DeleteProviderRateRequest} returns this
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.setBenefitCode = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.providers_messages.DeleteProviderRateRequest} returns this
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.clearBenefitCode = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.providers_messages.DeleteProviderRateRequest.prototype.hasBenefitCode = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.providers_messages.DeleteProviderRateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.providers_messages.DeleteProviderRateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.providers_messages.DeleteProviderRateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.DeleteProviderRateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.providers_messages.DeleteProviderRateResponse}
 */
proto.providers_messages.DeleteProviderRateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.providers_messages.DeleteProviderRateResponse;
  return proto.providers_messages.DeleteProviderRateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.providers_messages.DeleteProviderRateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.providers_messages.DeleteProviderRateResponse}
 */
proto.providers_messages.DeleteProviderRateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.providers_messages.DeleteProviderRateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.providers_messages.DeleteProviderRateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.providers_messages.DeleteProviderRateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.providers_messages.DeleteProviderRateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.providers_messages);
